import React from 'react';

import Paragraph from '../../Paragraph';

class StatisticsModal extends React.PureComponent {
  componentWillReceiveProps() {
    if (this.modalContent) {
      this.modalContent.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  render() {
    const {
      closePopup, classes, data, percent, gender,
    } = this.props;

    const genders = {
      male: 'men',
      female: 'women',
    };

    return (
      <div className={['modal-overlay statistics-modal', classes && classes].join(' ')}>
        <div className="modal-container">
          <button className="modal-close" onClick={closePopup}><span className="close-icon" /></button>

          <div className="modal-content" ref={(modalContent) => { this.modalContent = modalContent; }}>
            <div className="summary">
              <Paragraph classes="header-text" center>We’ve helped <br /><strong>{ data.clients }</strong> {(gender && genders[gender.toLowerCase()]) || 'people'} in <strong>{ data.district }</strong></Paragraph>

              <div className="highlight-info">
                <div className="snap-text" style={{ transform: 'translateX(-50%)', marginLeft: `calc(100% * ${percent / 100})` }}>You</div>
                <div className="highlightbar" />
                <div className="snap-text snap-bottom" style={{ transform: 'translateX(-50%)', marginLeft: `calc(100% * ${data.score / 40})` }}>{ data.district }</div>
                <div className="text-group">
                  <Paragraph classes="bar-text red">Unhealthy</Paragraph>
                  <Paragraph classes="bar-text green">Healthy</Paragraph>
                </div>
              </div>
            </div>

            { data.activity_clients >= 10 ?
              <div className="statistics-item blue">
                <Paragraph classes="section-image" center>
                  <img src="/site/images/campaign/activity-icon.svg" alt="activity" width="40" height="40" />
                </Paragraph>
                <Paragraph classes="section-text" center>Get active</Paragraph>
                <div className="flex-inline">
                  <div className="col-50">
                    <Paragraph classes="header-text">{ data.activity_clients }</Paragraph>
                    <Paragraph classes="desc-text">people are now more active.</Paragraph>
                  </div>
                </div>
                <div className="statistics-highlight">
                  <img src="/site/images/campaign/active-clock.svg" alt="active" />
                  <Paragraph classes="desc-text"><strong className="larger">{ data.activity_total_minutes } mins</strong><br />of activity per year</Paragraph>
                </div>
              </div>
            : null }
            { data.weight_clients >= 10 ?
              <div className="statistics-item purple">
                <Paragraph classes="section-image" center>
                  <img src="/site/images/campaign/wh-icon.svg" alt="hw" width="40" height="40" />
                </Paragraph>
                <Paragraph classes="section-text" center>Lose weight</Paragraph>
                <div className="flex-inline">
                  <div className="col-50">
                    <Paragraph classes="header-text">{ data.weight_clients }</Paragraph>
                    <Paragraph classes="desc-text">people have lost weight.</Paragraph>
                  </div>
                </div>
                <div className="statistics-highlight">
                  <img src="/site/images/campaign/hw-kangaroo.svg" alt="hw" />
                  <Paragraph classes="desc-text"><strong className="larger">{ (parseInt(data.weight_total_loss && data.weight_total_loss.replace(',', ''), 10) / 50).toFixed(1) } Kangaroos</strong><br /><strong>{ data.weight_total_loss }kg</strong> total weight loss.</Paragraph>
                </div>
              </div>
            : null }
            { data.smoking_clients >= 10 ?
              <div className="statistics-item red">
                <Paragraph classes="section-image" center>
                  <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="smoking" width="40" height="40" />
                </Paragraph>
                <Paragraph classes="section-text" center>Smoking</Paragraph>
                <div className="flex-inline">
                  <div className="col-50">
                    <Paragraph classes="header-text">{ data.smoking_clients }</Paragraph>
                    <Paragraph classes="desc-text">people have cut down their smoking.</Paragraph>
                  </div>
                </div>
                <div className="statistics-highlight">
                  <img src="/site/images/campaign/folder-icon.svg" alt="hw" />
                  <Paragraph classes="desc-text"><strong className="larger">£{ data.smoking_saved }</strong><strong> per person</strong><br />saved per year.</Paragraph>
                </div>
              </div>
            : null }
            { data.alcohol_clients >= 10 ?
              <div className="statistics-item yellow">
                <Paragraph classes="section-image" center>
                  <img src="/site/images/campaign/drinking-icon.svg" alt="drinking" width="40" height="40" />
                </Paragraph>
                <Paragraph classes="section-text" center>Drinking</Paragraph>
                <div className="flex-inline">
                  <div className="col-50">
                    <Paragraph classes="header-text">{ data.alcohol_clients }</Paragraph>
                    <Paragraph classes="desc-text">people have cut down their drinking.</Paragraph>
                  </div>
                </div>
                <div className="statistics-highlight">
                  <img src="/site/images/campaign/folder-icon.svg" alt="hw" />
                  <Paragraph classes="desc-text"><strong className="larger">£{ data.alcohol_saved }</strong><strong> per person</strong><br />saved per year.</Paragraph>
                </div>
              </div>
            : null }
          </div>
        </div>
      </div>
    );
  }
}

export default StatisticsModal;



// WEBPACK FOOTER //
// ./src/Components/Campaign/FormPages/StatisticsModal.jsx